var _title, _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgLogo = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 600 231",
  y: "-96px"
}, props), _title || (_title = /*#__PURE__*/React.createElement("title", null, "logo (1)-svg")), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".s0 { fill: #ffffff }")), _g || (_g = /*#__PURE__*/React.createElement("g", {
  id: "Layer"
}, /*#__PURE__*/React.createElement("path", {
  id: "Layer",
  fillRule: "evenodd",
  className: "s0",
  d: "m150.8 101.8h-25.4l-14.5-30.2h-0.2l-4.8 30.2h-20.3l12.4-78.5h30.5c15.5 0 26.1 7.4 23.5 24.1-1.7 10.8-9.2 20.2-20.7 22.2zm-38-43.3h2c6.7 0 14.4-1.2 15.7-9.8 1.3-8.5-5.9-9.8-12.6-9.8h-2z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Layer",
  className: "s0",
  d: "m186.4 40.6l-2.1 13.1h23l-2.7 17.3h-23l-2.1 13.5h24.2l-2.7 17.3h-44.7l12.4-78.4h44.7l-2.7 17.3z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Layer",
  className: "s0",
  d: "m236.7 84.6h24.5l-2.7 17.3h-44.9l12.4-78.5h20.4z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Layer",
  fillRule: "evenodd",
  className: "s0",
  d: "m354.4 61.1c-4 25.4-25.1 43.3-50.2 43.3-25.1 0-40.6-17.9-36.6-43.3 3.8-23.7 27.2-40.4 49.8-40.4 22.6 0 40.7 16.7 37 40.4zm-65.6 0.1c-2.1 13.5 6.3 23.4 18.5 23.4 12.2 0 23.7-9.9 25.9-23.4 1.7-10.8-6.7-20.7-18.9-20.7-12.2 0-23.8 9.9-25.5 20.7z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Layer",
  fillRule: "evenodd",
  className: "s0",
  d: "m379.6 88.2l-7.6 13.6h-21.6l42.6-78.5h22.3l17.2 78.5h-21.8l-2.9-13.6zm20.6-40.6h-0.2l-12.4 25h17z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Layer",
  fillRule: "evenodd",
  className: "s0",
  d: "m451.1 23.4h28.9c21.9 0 37.1 17.2 33.7 39.2-3.5 22.1-24.3 39.2-46.1 39.2h-28.9zm10.7 61.2h4.6c12.2 0 23.6-6.7 26.1-22 2.2-14.1-5.8-22-18.9-22h-4.8z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Layer",
  className: "s0",
  d: "m60.7 143.6l-2.1 13.1h22.4l-2.7 17.3h-22.4l-4.9 30.8h-20.3l12.4-78.5h45.1l-2.7 17.3z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Layer",
  fillRule: "evenodd",
  className: "s0",
  d: "m176.4 164.1c-4 25.4-25.1 43.3-50.2 43.3-25.1 0-40.6-17.9-36.6-43.3 3.8-23.7 27.2-40.4 49.8-40.4 22.6 0 40.7 16.7 37 40.4zm-65.6 0.1c-2.1 13.5 6.3 23.4 18.5 23.4 12.2 0 23.7-9.9 25.9-23.4 1.7-10.8-6.7-20.7-18.9-20.7-12.2 0-23.8 9.9-25.5 20.7z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Layer",
  fillRule: "evenodd",
  className: "s0",
  d: "m268.7 164.1c-4 25.4-25.1 43.3-50.2 43.3-25.1 0-40.6-17.9-36.6-43.3 3.8-23.7 27.2-40.4 49.8-40.4 22.6 0 40.7 16.7 37 40.4zm-65.6 0.1c-2.1 13.5 6.3 23.4 18.5 23.4 12.2 0 23.7-9.9 25.9-23.4 1.7-10.8-6.7-20.7-18.9-20.7-12.2 0-23.8 9.9-25.5 20.7z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Layer",
  fillRule: "evenodd",
  className: "s0",
  d: "m284.1 126.4h28.9c21.9 0 37.1 17.2 33.7 39.2-3.5 22.1-24.3 39.2-46.1 39.2h-28.9zm10.8 61.2h4.6c12.2 0 23.6-6.7 26.1-22 2.2-14.1-5.8-22-18.9-22h-4.8z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Layer",
  fillRule: "evenodd",
  className: "s0",
  d: "m350 204.8l12.4-78.5h29.1c13.9 0 22.5 5.4 20.1 20.4-1.1 7.1-4.3 12.8-11.2 16v0.2c11 1.5 14.6 9.1 12.9 20-2.6 16.4-17.5 21.9-31.9 21.9zm22.9-15.6h2.6c6 0 16.2 0.3 17.6-8.3 1.5-9.5-8.7-8.5-15.4-8.5h-2.1zm5-32h2.3c5.4 0 11.2-0.9 12.2-7.6 1.1-7.2-5.1-7.6-10.7-7.6h-1.5z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Layer",
  fillRule: "evenodd",
  className: "s0",
  d: "m442.6 191.2l-7.6 13.6h-21.6l42.6-78.5h22.3l17.2 78.5h-21.8l-2.9-13.6zm20.7-40.6h-0.2l-12.4 25h17z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Layer",
  fillRule: "evenodd",
  className: "s0",
  d: "m567 204.8h-25.4l-14.5-30.2h-0.2l-4.8 30.2h-20.4l12.4-78.5h30.5c15.5 0 26.1 7.4 23.5 24.1-1.7 10.8-9.2 20.2-20.7 22.2zm-38-43.3h2c6.7 0 14.4-1.2 15.7-9.8 1.3-8.5-5.9-9.8-12.6-9.8h-2z"
}))));
export { SvgLogo as ReactComponent };